import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {
  Typography
} from '@material-ui/core';

const styles = theme => ({
  root: {
    margin: '0px',
    padding: '50px 0px',
    backgroundColor: '#565656',
  },
  title: {
    color: '#232323',
  }
});

class Footer extends Component {

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="caption" align="center" className={classes.title}>
          © 2018 GRENARCH Technologies, LLC
        </Typography>
      </div>
    );
  }
};

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);



// WEBPACK FOOTER //
// ./src/components/common/Footer.js